import styled from 'styled-components';
import { breakpoints, colors } from '../../constants';

export const MobileOnly = styled.div`
    color: ${colors.greenDark};

    @media (${breakpoints.mediumMin}) {
        display: none;
    }
`;
